import { navMenu } from "@lib/data"
import type { SupportedLocale as Lang } from "@site-types/site"
import { Fragment } from "react"
import "./styles.css"

export function NavMenu({ locale, page }: { locale: Lang; page: string }) {
  return (
    <ul>
      {navMenu(locale).map((item) => (
        <Fragment key={item.label}>
          {item.page === "index" ? (
            <li
              className="nav-separator"
              aria-hidden="true"
            />
          ) : null}
          <li className={page === item.page ? "active" : ""}>
            <a
              aria-label={item.label}
              href={item.href}
              target={item.external ? "_blank" : undefined}
              rel={item.external ? "noreferrer" : undefined}
            >
              <i className={item.icon} />
              <span>{item.label}</span>
            </a>
          </li>
        </Fragment>
      ))}
    </ul>
  )
}

export default NavMenu
